import { memo } from 'react';

import isEqual from 'lodash/isEqual';

import UpliftTooltipIcon from '@/components/Icon/UpliftTooltipIcon';

type TProps = {
  'aria-label'?: string;
  className?: string;
  icon?: React.ReactNode;
};

const UpliftTooltip = memo(({ 'aria-label': ariaLabel, className, icon }: TProps) => {
  return (
    <span aria-label={ariaLabel} className={className} data-up-tooltip="">
      {icon || <UpliftTooltipIcon />}
    </span>
  );
}, isEqual);

UpliftTooltip.displayName = 'UpliftTooltip';

export default UpliftTooltip;
